<template>
  <Card dis-hover class="rule-card">
    <template #title>
      <div class="font-weight-bold font-size-17 color-333">{{ $t('key1002177') }}</div>
    </template>
    <Form ref="productSalesPriceConfigForm" :model="productSalesPriceConfigForm" :rules="productSalesPriceConfigRule"
      :label-width="130" :disabled="productSalesPriceConfigType === 'look'" @submit.native.prevent class="productSalesPriceConfig_box">
      <FormItem :label="$t('key1001437')" prop="ruleName">
        <Input v-model.trim="productSalesPriceConfigForm.ruleName" clearable style="width:300px"></Input>
      </FormItem>
      <!-- 收费项 -->
      <FormItem :label="costLabel">
        <div class="flex align-items-center font-size-12">
          <span>{{ priceText }}</span>
          <!-- 加价比例 -->
          <FormItem prop="markupPercentage" style="margin-bottom: 0;">
            <InputNumber
              placeholder="0"
              style="width: 130px"
              :min="0"
              :max="9999999"
              :formatter="(value) => formatterNumber(value, 2)"
              v-model.trim="productSalesPriceConfigForm.markupPercentage"/>
          </FormItem>
          <span class="ml8 mr8">%</span>
          <span> + {{ $t('key1003440') }}</span>
          <!-- 固定金额 -->
          <FormItem prop="fixedMarkupAmount" style="margin-bottom: 0;">
            <InputNumber
              placeholder="0"
              style="width: 130px"
              :min="0"
              :max="9999999"
              :formatter="(value) => formatterNumber(value, 2)"
              v-model.trim="productSalesPriceConfigForm.fixedMarkupAmount"/>
          </FormItem>
          <span class="ml4">{{ currency || currencyState }}</span>
        </div>
      </FormItem>
      <!--批发模式-->
      <template v-if="showProductWholesaleModel">
        <FormItem :label="wholesaleCostLabel">
          <div class="flex align-items-center font-size-12">
            <span>{{ priceText }}</span>
            <!-- 加价比例 -->
            <FormItem prop="wholesaleMarkupPercentage" style="margin-bottom: 0;">
              <InputNumber
                placeholder="0"
                style="width: 130px"
                :min="0"
                :max="9999999"
                :formatter="(value) => formatterNumber(value, 2)"
                v-model.trim="productSalesPriceConfigForm.wholesaleMarkupPercentage"/>
            </FormItem>
            <span class="ml8 mr8">%</span>
            <span> + {{ $t('key1003440') }}</span>
            <!-- 固定金额 -->
            <FormItem prop="wholesaleFixedMarkupAmount" style="margin-bottom: 0;">
              <InputNumber
                placeholder="0"
                style="width: 130px"
                :min="0"
                :max="9999999"
                :formatter="(value) => formatterNumber(value, 2)"
                v-model.trim="productSalesPriceConfigForm.wholesaleFixedMarkupAmount"/>
            </FormItem>
            <span class="ml4">{{ currency || currencyState }}</span>
          </div>
        </FormItem>
      </template>
    </Form>
  </Card>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {amountHandel, formatterNumber, isValueEmpty} from "@/utils/common";
import api from '@/api/';

export default {
  name: 'productSalesPriceConfigRulesModal',
  mixins: [Mixin],
  props: {
    // 是否开启批发模式
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let v = this;
    return {
      productSalesPriceConfigForm: {
        ruleName: '',
        markupPercentage: null,
        fixedMarkupAmount: null,
        wholesaleMarkupPercentage: null,
        wholesaleFixedMarkupAmount: null
      },
      configStatus: '1',
      autoRuleId: null,
      productSalesPriceConfigType: 'add',
      paramsKeys: null,
      currency: null,
      rulesList: [],
    }
  },
  computed: {
    costLabel() {
      let text = this.showProductWholesaleModel ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000916') : '';
      return this.configStatus === '1' ? `${text}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003433')}` : `${text}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003434')}`;
    },
    wholesaleCostLabel() {
      return this.configStatus === '1' ? `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003435')}` : `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003436')}`;
    },
    priceText() {
      return this.configStatus === '1' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003437') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003438');
    },
    productSalesPriceConfigRule() {
      return {
        ruleName: [{required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001334'), trigger: 'blur'}]
      }
    }
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initProductSalesPriceConfigRulesData(detailsData, type, obj) {
      this.configStatus = obj.configStatus;
      this.productSalesPriceConfigType = type;
      const prefix = obj.configStatus === '1' ? 'ymsProductPrice' : 'ymsProductPriceService';
      const suffix = obj.configValue === 'commonConfig' ? 'CommonRule' : 'MerchantRule';
      this.paramsKeys = `${prefix}${suffix}`;
      if (detailsData) {
        let {selectedRule} = detailsData;
        let ruleActions = detailsData.ruleActions || [];
        this.rulesList = detailsData.rules || [];
        if (ruleActions.length > 0) {
          ruleActions.map((item) => {
            if (item.type === this.paramsKeys) {
              let list = JSON.parse(item.value) || [];
              if (list.length > 0) {
                list.map((ele) => {
                  switch (ele.floatType) {
                    case 1:
                      this.productSalesPriceConfigForm.markupPercentage = Number(amountHandel(ele.floatNum));
                      break;
                    case 3:
                      this.productSalesPriceConfigForm.fixedMarkupAmount = Number(amountHandel(ele.floatNum));
                      this.currency = ele.currency;
                      break;
                    case 5:
                      this.productSalesPriceConfigForm.wholesaleMarkupPercentage = Number(amountHandel(ele.floatNum));
                      break;
                    case 7:
                      this.productSalesPriceConfigForm.wholesaleFixedMarkupAmount = Number(amountHandel(ele.floatNum));
                      this.currency = ele.currency;
                      break;
                  }
                });
                if (this.showProductWholesaleModel) {
                  if (this.productSalesPriceConfigForm.wholesaleMarkupPercentage === null &&
                    this.productSalesPriceConfigForm.wholesaleFixedMarkupAmount === null) {
                    this.productSalesPriceConfigForm.wholesaleMarkupPercentage = JSON.parse(JSON.stringify(this.productSalesPriceConfigForm.markupPercentage));
                    this.productSalesPriceConfigForm.wholesaleFixedMarkupAmount = JSON.parse(JSON.stringify(this.productSalesPriceConfigForm.fixedMarkupAmount));
                  }
                }
              }
            }
          })
        }
        this.productSalesPriceConfigForm.ruleName = selectedRule?.name || '';
        this.autoRuleId = selectedRule?.autoRuleId || null;
      }
    },
    // 确定按钮
    productSalesPriceConfigBtn(params) {
      let v = this;
      let val = isValueEmpty(v.productSalesPriceConfigForm.fixedMarkupAmount) ? 0 :
        Number(v.productSalesPriceConfigForm.fixedMarkupAmount.toFixed(2))
      let list = [
        {
          floatType: 1, // 1 上浮、2 下浮 、3 加价 、4 减价 、5 批发价上浮 、6 批发价下浮 、7 批发价加价 、8 批发价减价
          floatNum: Number(amountHandel(v.productSalesPriceConfigForm.markupPercentage)),
        },
        {
          floatType: 3,
          floatNum: val,
          currency: v.currencyState,
        },
      ];
      if (v.showProductWholesaleModel) {
        let value = isValueEmpty(v.productSalesPriceConfigForm.wholesaleFixedMarkupAmount) ? 0 :
          Number(v.productSalesPriceConfigForm.wholesaleFixedMarkupAmount.toFixed(2))
        list.push(
          {
            floatType: 5,
            floatNum: Number(amountHandel(v.productSalesPriceConfigForm.wholesaleMarkupPercentage)),
          },
          {
            floatType: 7,
            floatNum: value,
            currency: v.currencyState,
          }
        );
      }
      let query = {
        autoRuleId: v.autoRuleId,
        autoRuleActions: [{
          type: v.paramsKeys,
          value: JSON.stringify(list)
        }],
        autoRuleItems: params,
        name: v.productSalesPriceConfigForm.ruleName,
        ymsRuleType: v.paramsKeys
      };

      let configMap = {
        add: {
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456'),
          url: v.configStatus === '1' ? api.post_ymsProductPriceRule : api.post_ymsProductPriceServiceRule,
          method: 'post'
        },
        edit: {
          successText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279'),
          url: v.configStatus === '1' ? api.put_ymsProductPriceRule : api.put_ymsProductPriceServiceRule,
          method: 'put'
        }
      }
      // 校验----> 操作对象(至少选一个)
      let requiredDistributorTalg = true;
      let requiredCommodityTalg = true;
      let requiredDistributorKeys = [];
      let requiredCommodityKeys = [];
      if (['ymsProductPriceMerchantRule', 'ymsProductPriceServiceMerchantRule'].includes(v.paramsKeys)) {
        if (this.rulesList.length > 0) {
          // 分销商--必填的规则id
          requiredDistributorKeys = this.rulesList.filter((item) => {
            return item.group === 'target';
          }).map((item) => {
            return item.id;
          });
          // 商品--必填的规则id
          requiredCommodityKeys = this.rulesList.filter((item) => {
            return item.group === 'PRODUCT';
          }).map((item) => {
            return item.id;
          });
        }
        requiredDistributorTalg = params.some((item) => {
          return requiredDistributorKeys.includes(item.ruleCode);
        });
        requiredCommodityTalg = params.some((item) => {
          return requiredCommodityKeys.includes(item.ruleCode);
        });
      }
      if (requiredDistributorTalg && requiredCommodityTalg) {
        const config = configMap[v.productSalesPriceConfigType];
        if (config) {
          let {method, successText, url} = config;
          v.$refs['productSalesPriceConfigForm'].validate((valid, err) => {
            if (valid) {
              v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
                if (response.data.code === 0) {
                  v.$Message.success(successText);
                  v.$emit('updateProductSalesPriceConfigRule', true);
                }
              });
            }
          });
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003439'));
        return false;
      }
    },
    // 重置数据
    reset() {
      this.$refs['productSalesPriceConfigForm'].resetFields();
      this.productSalesPriceConfigForm.markupPercentage = null;
      this.productSalesPriceConfigForm.fixedMarkupAmount = null;
      this.productSalesPriceConfigForm.wholesaleMarkupPercentage = null;
      this.productSalesPriceConfigForm.wholesaleFixedMarkupAmount = null;
      this.autoRuleId = null;
    }
  }
};
</script>

<style lang="less" scoped>
.productSalesPriceConfig_box {
  /deep/ .ivu-form-item-label {
    padding-right: 0;
    font-size: 12px;
    color: #333;
    font-weight: bold;
  }
}
</style>
